import SEO from '../components/SEO';

export default function Terms() {
  return (
    <>
      <SEO title="Terms & Conditions | Laraé Logistics" description="Terms and conditions governing removals services from Laraé Logistics." />
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-5 md:px-8 lg:px-12">
          <h1 className="font-outfit text-4xl md:text-5xl font-medium text-ink tracking-tight">Terms &amp; Conditions</h1>
          <p className="font-manrope text-sm text-ink/55 mt-2">Last updated: January 2026</p>
          <div className="mt-8 font-manrope text-base text-ink/75 leading-relaxed space-y-4">
            <h2 className="font-outfit text-xl font-semibold text-ink mt-6">1. The contract</h2>
            <p>By booking a service from Laraé Logistics you agree to these terms. A booking is confirmed when we receive the agreed deposit.</p>
            <h2 className="font-outfit text-xl font-semibold text-ink mt-6">2. Quotes and pricing</h2>
            <p>Quotes are based on the information you provide. If the actual scope of work materially differs, we reserve the right to revise the price before commencing the job, with your agreement.</p>
            <h2 className="font-outfit text-xl font-semibold text-ink mt-6">3. Payment</h2>
            <p>No deposit is required to secure a booking. Payment is due on completion of the move, payable by bank transfer, card or cash.</p>
            <h2 className="font-outfit text-xl font-semibold text-ink mt-6">4. Insurance</h2>
            <p>All work is covered by £10,000 Goods in Transit insurance and £1,000,000 Public Liability cover. Items of unusually high value should be declared in advance.</p>
            <h2 className="font-outfit text-xl font-semibold text-ink mt-6">5. Cancellation</h2>
            <p>Cancellations made more than 48 hours before the booked move date are free of charge. Cancellations within 48 hours of the booked move date are subject to a 50% cancellation fee due to vehicle, staffing and resource allocation.</p>
            <h2 className="font-outfit text-xl font-semibold text-ink mt-6">6. Claims</h2>
            <p>Any claim for damage or loss must be made in writing within 7 days of completion of the move.</p>
            <h2 className="font-outfit text-xl font-semibold text-ink mt-6">7. Governing law</h2>
            <p>These terms are governed by the laws of England and Wales.</p>
          </div>
        </div>
      </section>
    </>
  );
}
